import React from 'react'
import RehabPathLogo from '../RehabPathLogo/RehabPathLogo'

const RehabPathLogoLinked = (props) => {
  const { title, href } = getLinkTitleAndHref(props)

  const handleClick = () => {
    window.scrollTo(0, 0)
  }

  return (
    <a
      className="relative block h-inherit w-inherit"
      title={title}
      href={href}
      onClick={handleClick}
    >
      <RehabPathLogo {...props} />
    </a>
  )
}

const getLinkTitleAndHref = ({
  isLuxury,
  isUnitedKingdomPage,
  isEatingDisorders,
  isSoberLiving
}) => {
  if (isLuxury) {
    return {
      title: 'Recovery.com Luxury Rehabs',
      href: '/luxury/'
    }
  }

  if (isUnitedKingdomPage) {
    return {
      title: 'Recovery.com UK',
      href: '/united-kingdom/'
    }
  }

  if (isEatingDisorders) {
    return {
      title: 'Recovery.com Eating Disorders',
      href: '/condition/eating-disorders/'
    }
  }

  if (isSoberLiving) {
    return {
      title: 'Recovery.com Sober Living',
      href: '/care/sober-living/'
    }
  }

  return {
    title: 'Recovery.com Home',
    href: '/'
  }
}

export default RehabPathLogoLinked
